import styled from 'styled-components';
import { COLORS, MAX_WIDTH } from '../../constants/theme';

export const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 1rem 2rem;
  background: rgba(26, 26, 26, 0.95);
  backdrop-filter: blur(10px);
  z-index: 1000;
  border-bottom: 1px solid ${COLORS.whiteSubtle};
`;

export const Nav = styled.nav`
  max-width: ${MAX_WIDTH};
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${COLORS.white};
  span {
    color: ${COLORS.pink};
  }
`;

export const NavLinks = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;

  a {
    color: ${COLORS.whiteTransparent};
    text-decoration: none;
    transition: color 0.3s;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    &:hover {
      color: ${COLORS.cyan};
    }

    svg {
      font-size: 0.9em;
    }
  }
`;

export const LanguageToggle = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-left: 2rem;
`;

export const LangButton = styled.button`
  background: ${props => props.active ? COLORS.blue : 'transparent'};
  color: ${COLORS.white};
  border: 1px solid ${props => props.active ? COLORS.blue : '#666'};
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  width: auto;

  &:hover {
    background: ${props => props.active ? COLORS.blue : '#333'};
  }
`;

export const FooterContainer = styled.footer`
  background: rgba(0, 0, 0, 0.5);
  padding: 4rem 2rem 2rem;
  border-top: 1px solid ${COLORS.whiteSubtle};
`;

export const FooterContent = styled.div`
  max-width: ${MAX_WIDTH};
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 3rem;

  h4 {
    color: ${COLORS.pink};
    margin-bottom: 1rem;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      margin-bottom: 0.5rem;

      a {
        color: rgba(255, 255, 255, 0.7);
        text-decoration: none;
        transition: color 0.3s;

        &:hover {
          color: ${COLORS.cyan};
        }
      }
    }
  }
`;

export const WazaFooter = styled.div`
  text-align: center;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid ${COLORS.whiteSubtle};
  color: rgba(255, 255, 255, 0.6);

  p {
    margin: 0.5rem 0;
  }

  .waza-highlight {
    color: ${COLORS.pink};
    font-weight: bold;
  }

  .heart {
    color: ${COLORS.pink};
    display: inline-block;
    margin: 0 0.3rem;
    animation: pulse 1.5s ease infinite;
  }

  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }
`;
